module.exports = __webpack_public_path__ + "img/aimPoint1.bc3ff7f4.png";